import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, ActivityIcon } from 'lucide-react';
interface CalorieSummaryProps {
  caloriesIn: number;
  caloriesOut: number;
}
export function CalorieSummary({
  caloriesIn,
  caloriesOut
}: CalorieSummaryProps) {
  const net = caloriesIn - caloriesOut;
  const isDeficit = net < 0;
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-15">
      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 transition-all hover:border-gray-600" data-id="element-16">
        <div className="flex items-center justify-between mb-2" data-id="element-17">
          <span className="text-gray-400 text-sm font-medium" data-id="element-18">Calories In</span>
          <TrendingUpIcon className="w-5 h-5 text-green-500" data-id="element-19" />
        </div>
        <div className="text-3xl font-bold text-white mb-1" data-id="element-20">{caloriesIn}</div>
        <div className="text-xs text-gray-500" data-id="element-21">kcal consumed</div>
      </div>

      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 transition-all hover:border-gray-600" data-id="element-22">
        <div className="flex items-center justify-between mb-2" data-id="element-23">
          <span className="text-gray-400 text-sm font-medium" data-id="element-24">
            Calories Out
          </span>
          <ActivityIcon className="w-5 h-5 text-blue-500" data-id="element-25" />
        </div>
        <div className="text-3xl font-bold text-white mb-1" data-id="element-26">{caloriesOut}</div>
        <div className="text-xs text-gray-500" data-id="element-27">kcal burned</div>
      </div>

      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 transition-all hover:border-gray-600" data-id="element-28">
        <div className="flex items-center justify-between mb-2" data-id="element-29">
          <span className="text-gray-400 text-sm font-medium" data-id="element-30">Net</span>
          {isDeficit ? <TrendingDownIcon className="w-5 h-5 text-green-500" data-id="element-31" /> : <TrendingUpIcon className="w-5 h-5 text-orange-500" data-id="element-32" />}
        </div>
        <div className={`text-3xl font-bold mb-1 ${isDeficit ? 'text-green-500' : 'text-orange-500'}`} data-id="element-33">
          {isDeficit ? '' : '+'}
          {net}
        </div>
        <div className="text-xs text-gray-500" data-id="element-34">
          {isDeficit ? 'deficit' : 'surplus'}
        </div>
      </div>
    </div>;
}